import Employees from '@/views/constants/employees';
import NewEmployee from '@/views/constants/employee-new';
import EmployeesResource from '@/resources/constants/employees';

const Steps = {
  create () {
    return [{
      number: 1,
      title: 'Invoer persoonsgegevens',
      text: 'Voer de persoonsgegevens van de werknemer die u wilt opvoeren in.',
      completed: false,
      active: true,
      view: NewEmployee.Views.Personal,
      navigateAction: NewEmployee.Actions.Navigate.DO
    },
    {
      number: 2,
      title: 'Invoer werkgerelateerde gegevens',
      text: 'Voer de werkgerelateerde gegevens van de werknemer die u wilt opvoeren in.',
      completed: false,
      active: false,
      view: NewEmployee.Views.Employment,
      navigateAction: NewEmployee.Actions.Navigate.DO
    },
    {
      number: 3,
      title: 'Bevestig nieuwe werknemer',
      text: 'Controleer alle gegevens en geef bevestiging om de nieuwe werknemer daadwerkelijk op te voeren.',
      completed: false,
      active: false,
      view: NewEmployee.Views.Confirmation,
      navigateAction: NewEmployee.Actions.Navigate.DO
    }];
  }
};

const state = {
  newEmployeeSteps: Steps.create()
};

const getters = {
  newEmployeeSteps: state => state.newEmployeeSteps,
  newEmployeeActiveView: state => state.newEmployeeSteps.find(s => s.active).view
};

const actions = {
  [NewEmployee.Actions.Navigate.DO] ({ commit, rootGetters }, view) {
    if (view !== NewEmployee.Views.Personal) {
      if (!(rootGetters.newEmployeeValidations.isValid() && rootGetters.newEmployeeRequiredFields.isValid())) {
        return;
      }
    }

    if (view === NewEmployee.Views.Confirmation) {
      let relationshipFields = rootGetters.newEmployeeEmploymentRelationshipRequiredFields.isValid();
      let relationshipValidations = rootGetters.newEmployeeEmploymentRelationshipValidations.isValid();

      let detailFields = rootGetters.newEmployeeEmploymentRelationshipDetailRequiredFields.isValid();
      let detailValidations = rootGetters.newEmployeeEmploymentRelationshipDetailValidations.isValid();

      if (!(relationshipFields && relationshipValidations && detailFields && detailValidations)) {
        return;
      }
    }

    commit(NewEmployee.Mutations.ActiveView.SET, view);
  },

  [NewEmployee.Actions.Steps.Completed.UPDATE] ({ commit, rootGetters }) {
    commit(NewEmployee.Mutations.Steps.Completed.SET, {
      personalRequiredFields: rootGetters.newEmployeeValidations,
      personalValidations: rootGetters.newEmployeeRequiredFields,

      relationshipRequiredFields: rootGetters.newEmployeeEmploymentRelationshipRequiredFields,
      relationshipValidations: rootGetters.newEmployeeEmploymentRelationshipValidations,

      detailRequiredFields: rootGetters.newEmployeeEmploymentRelationshipDetailRequiredFields,
      detailValidations: rootGetters.newEmployeeEmploymentRelationshipDetailValidations
    });
  },

  [EmployeesResource.Actions.Create.SUCCESS] ({ commit }) {
    commit(NewEmployee.Mutations.ActiveView.CLEAR);
  },

  [NewEmployee.Actions.Cancel.DO] ({ commit }) {
    commit(NewEmployee.Mutations.ActiveView.CLEAR);
  },

  [Employees.Actions.Tabs.CLOSE] ({ commit }, tab) {
    if (tab.component === 'NewEmployee') {
      commit(NewEmployee.Mutations.ActiveView.CLEAR);
    }
  }
};

const mutations = {
  [NewEmployee.Mutations.ActiveView.SET] (state, payload) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    state.newEmployeeSteps.forEach(s => {
      s.active = (s.view === payload);
    });
  },

  [NewEmployee.Mutations.ActiveView.CLEAR] (state) {
    state.newEmployeeSteps = Steps.create();
  },

  [NewEmployee.Mutations.Steps.Completed.SET] (state, payload) {
    state.newEmployeeSteps.forEach(s => {
      switch (s.view) {
        case NewEmployee.Views.Personal:
          s.completed = payload.personalRequiredFields.isValid() && payload.personalValidations.isValid();
          break;
        case NewEmployee.Views.Employment:
          s.completed = payload.relationshipRequiredFields.isValid() && payload.relationshipValidations.isValid() &&
            payload.detailRequiredFields.isValid() && payload.detailValidations.isValid();
          break;
      }
    });
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
